import PropTypes from 'prop-types';
import React from 'react';
import SanitizedHtml from '../SanitizedHtml';

const OfferDetails = ({ offer: { highlights } }) => (
  <div className='max-width-div add-margin w-clearfix'>
    <div className='offer-column'>
      <div className='black-44'> Highlights</div>
      <div className='highlight'>{<SanitizedHtml html={highlights} />}</div>
    </div>
  </div>
);

OfferDetails.propTypes = {
  offer: PropTypes.object.isRequired,
};

export default OfferDetails;



// WEBPACK FOOTER //
// ./src/components/OfferOverview/OfferHighlights.js